import { useUserContext } from '@/contexts/UserContext';
import { useToggle } from '@netfront/common-library';
import { useDomain, useLogout } from '@netfront/gelada-identity-library';
import { Dropdown } from '@netfront/ui-library';
import Link from 'next/link';
import { useRouter } from 'next/router';
import UserAvatar from './UserAvatar';

export const UserMenu = () => {
  const { push } = useRouter();
  const { getDomain } = useDomain();
  const { user } = useUserContext();
  const { isToggled: isMenuOpen, toggle: toggleMenu } = useToggle();

  const { handleLogout } = useLogout({
    onCompleted: () => push('/'),
  });

  return (
    <Dropdown
      additionalClassNames="c-user-menu spotlight-item--9"
      dropdownId="user-menu"
      isDisplayContent={isMenuOpen}
      trigger={<UserAvatar />}
      onDisplayContent={toggleMenu}
    >
      {user && (
        <ul className="c-user-menu__dropdown shadow">
          <li className="c-user-menu__item">
            <div className="c-user-menu__header">
              <p className="c-user-menu__title">
                {user.firstName} {user.lastName}
              </p>
              <p className="c-user-menu__description">{user.credential.email}</p>
            </div>
          </li>
          <li className="c-user-menu__item">
            <Link href="/console/account">Account</Link>
          </li>
          <li className="c-user-menu__item">
            <Link href="/contact">Contact us</Link>
          </li>
          <li className="c-user-menu__item">
            <button className="c-user-menu__item" onClick={() => handleLogout({ domain: getDomain(), path: '/' })}>
              Logout
            </button>
          </li>
        </ul>
      )}
    </Dropdown>
  );
};
